import type { BrandFeature } from "@src/domain/entities/brand";
import type { UpdateBrandFeatureStatusDTO } from "@src/domain/dto/brands";
import type { IBrandRepository } from "@src/domain/repositories/brand";

export class UpdateBrandFeatureStatusUseCase {
  private readonly brandRepository: IBrandRepository;

  constructor(brandRepository: IBrandRepository) {
    this.brandRepository = brandRepository;
  }

  async execute(params: UpdateBrandFeatureStatusDTO): Promise<BrandFeature> {
    try {
      const updatedFeature =
        await this.brandRepository.updateBrandFeatureStatus(params);
      if (!updatedFeature) {
        throw new Error("No brand feature returned");
      }
      return updatedFeature;
    } catch (error) {
      console.error("Failed to update brand feature status:", error);
      throw new Error("Failed to update brand feature status");
    }
  }
}
